import Api from "./Api";

class SupplierAPI extends Api{

    get(supplierId){

        let path = "/supplier/" + supplierId;

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)
        //return this._post(endpoint,{}).then(response =>  response)
    }

    getOrders(supplierId){

        let path = "/supplier/" + supplierId + "/order";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)
        //return this._post(endpoint,{}).then(response =>  response)
    }

    update(supplierId,data){

        let path = "/supplier/" + supplierId;
        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._put(endpoint,data)
    }

    new(data){
        let path = "/supplier/new";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._post(endpoint,data)
    }

    search(condition,page){
        let path = "/search";
        if (page){
            path += ("?p=" + page);
        }
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._post(endpoint,condition)
    }

}

let _api = new SupplierAPI();

export default _api;